import {Component, forwardRef, Inject, ViewChild} from '@angular/core';
import {Field, FieldType} from '../../common/field';
import {Helper} from '../../common/helper';
import {BaseModalComponent} from '../../components/base.modal.component';
import {FieldsListComponent} from '../../components/fields-list.component';
import {ProfileService} from '../../services/profile.service';
import {ProfilesComponent} from './profiles.component';
import {AppComponent} from '../../app.component';
import 'moment-timezone';
import {UserBean, UserProfileBean} from '../../model/model';

@Component({
    selector: 'customer-edit-component',
    templateUrl: 'customer.edit.component.html'
})

export class CustomerEditComponent {

    user: UserBean = {} as UserBean;

    @ViewChild(BaseModalComponent, {static: false}) base: BaseModalComponent;
    @ViewChild('fieldsListComponent', {static: false}) fieldsListComponent: FieldsListComponent;
    @ViewChild('profileFieldsListComponent', {static: false}) profileFieldsListComponent: FieldsListComponent;

    fields: Field[] = [
        new Field('rewardPoints', 'Reward Points', FieldType.NUMBER),
    ];
    profileFields: Field[] = [
        new Field('allowMarketing', 'Allow Marketing', FieldType.CHECKBOX).disable(),
    ];

    userProfile: UserProfileBean = {} as UserProfileBean;

    constructor(private profileService: ProfileService,
        @Inject(forwardRef(() => ProfilesComponent)) private parent: ProfilesComponent,
        @Inject(forwardRef(() => AppComponent)) private app: AppComponent) {
    }

    open(user: UserBean, companyId: number, title: string) {

        this.user = (user ? Helper.copyObject(user) : {} as UserBean);
        this.base.show(title + ' <' + this.user.displayName + '>');

        this.userProfile = {} as UserProfileBean;

        this.profileService.getProfile(companyId, user.id).subscribe(response => {
            if (response && response.success) {
                this.userProfile = response.value;
            }
        });

    }

    save() {

        this.profileService.setRewardPoints(this.user.id, this.user.rewardPoints).subscribe(response => {

            if (response.success) {
                this.parent.load();

            } else {

                this.app.showError('Can\'t update user');
            }
        }, error => {
            this.app.showError('Can\'t update user');
        });

    }

    resetPhoneNumberValidation() {

        this.profileService.resetPhoneNumberValidation(this.user.id).subscribe(response => {

            if (response.success) {
                this.app.showNotification('Reset completed.');

            } else {

                this.app.showError('Can\'t update user');
            }
        }, error => {
            this.app.showError('Can\'t update user');
        });

    }
}
